module.exports = __webpack_public_path__ + "static/media/file-check.a3abe0cd.svg";